module.exports = __webpack_public_path__ + "static/img/063_TO8_1622.7cd0954.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/063_TO8_1622.jpg
// module id = w10B
// module chunks = 0